<div class="label" *ngIf="title">
    <div class="label-title">
        {{title}}
    </div>
</div>
<div class="media" *ngIf="icon">
    <ng-content select="fui-icon"></ng-content>
</div>
